// All available modules/components in the organization
// These correspond to the navigation items in the sidebar

export const AVAILABLE_MODULES = [
  { id: "dashboard", label: "Dashboard" },
  { id: "employees", label: "Employees" },
  { id: "contract-staff", label: "Contract Staff Management" },
  { id: "job-descriptions", label: "Job Descriptions" },
  { id: "payroll", label: "Payroll" },
  { id: "attendance", label: "Attendance" },
  { id: "e-wallet", label: "E-Wallet" },
  { id: "engagement", label: "Engagement" },
  { id: "surveys", label: "Employee Surveys" },
  { id: "recruitement", label: "Recruitment" },
  { id: "talent-management", label: "Talent Management" },
  { id: "requests", label: "Requests" },
  { id: "chats", label: "Chats" },
  { id: "productivity", label: "Productivity" },
  { id: "documents", label: "Documents" },
  { id: "query-management", label: "Query Management" },
  { id: "conflict-resolution", label: "Conflict Resolution" },
  { id: "performance-evaluation", label: "Performance Evaluation" },
  { id: "reporting", label: "Reports & Intelligence" },
  { id: "company-settings", label: "Company Settings" },
  { id: "profile", label: "Profile" },
];

export const MODULE_BY_PATH = {
  "/employee": "employees",
  "/contract-staff": "contract-staff",
  "/job-descriptions": "job-descriptions",
  "/guarantor-forms": "job-descriptions",
  "/engagement": "engagement",
  "/recruitment": "recruitement",
  "/recruitement": "recruitement",
  "/talent-management": "talent-management",
  "/requests": "requests",
  "/attendance": "attendance",
  "/e-wallet": "e-wallet",
  "/payroll": "payroll",
  "/chat": "chats",
  "/productivity": "productivity",
  "/resources": "documents",
  "/query-management": "query-management",
  "/conflict-resolution": "conflict-resolution",
  "/performance-evaluation": "performance-evaluation",
  "/reporting": "reporting",
  "/surveys": "surveys",
  "/company-settings": "company-settings",
  "/profile": "profile",
};

export const getModuleLabel = (moduleId) => {
  const module = AVAILABLE_MODULES.find((m) => m.id === moduleId);
  return module ? module.label : moduleId;
};

export const getModuleLabels = (moduleIds) => {
  if (!moduleIds || !Array.isArray(moduleIds)) return [];
  return moduleIds.map((id) => getModuleLabel(id));
};
